var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgQuotesBoxUp = function SvgQuotesBoxUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 93,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 61.293l.003-8.08 6.025.002-1.328 6.38h25.512v32.42L0 61.293z",
    fill: "#FF8F8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.292 0H0v61.293h61.292V0z",
    fill: "#FF8F8F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.223 61.251L0 61.249l15.112 2.63 15.111 2.63v-5.258z",
    fill: "#FF6161"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.101 16c1.028 0 1.862.09 2.505.268l-.309 5.868c-3.082.409-4.867 2.428-5.355 6.059h5.355L27.757 42H12l.154-12.616c.077-5.19 2.35-9.012 6.82-11.467C21.31 16.64 23.687 16 26.1 16zm20.061 0c1.028 0 1.863.09 2.505.268l-.309 5.868c-3.082.409-4.867 2.428-5.355 6.059h5.355L47.82 42H32.061l.154-12.616c.077-5.19 2.35-9.012 6.82-11.467C41.372 16.64 43.748 16 46.162 16z",
    fill: "#fff"
  })));
};
export default SvgQuotesBoxUp;